import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import mutations from './mutations'
import actions from './actions'

const state = {
    isLogin: localStorage.getItem("isLogin"),   // 是否登录
    userInfo: window.JSON.parse(localStorage.getItem("userInfo")), // 用户信息
    userId: localStorage.getItem("userId"),
    currentAddress:localStorage.getItem("currentAddress"),//获取的地址
}
export default new Vuex.Store({
    state,
    mutations,
    actions
});



// WEBPACK FOOTER //
// ./src/store/index.js